import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '~/api/queryKeys';

import { fetchGoogleContentAttributes } from '../services/google-catalog-attributes.service';

/**
 * The Google curated attribute taxonomy, cached for the session: it is baked into the
 * agent image, so it cannot change between requests. `enabled` defers the fetch until
 * the consumer (the run panel) actually opens.
 */
export function useGoogleCatalogAttributes(enabled: boolean, selectableOnly = true) {
  return useQuery({
    queryKey: queryKeys.agents.googleContentAttributes(selectableOnly),
    queryFn: () => fetchGoogleContentAttributes(selectableOnly),
    enabled,
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
